import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material';
import { NewVersionComponent } from '../../new-version/new-version.component';

import { AuthService } from '../../auth.service';

import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-add-new-version',
  templateUrl: './add-new-version.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../../style.scss', './add-new-version.component.css']
})
export class AddNewVersionComponent implements OnInit {

  date = new Date();

  msgs: Message[];

  constructor(public dialog: MatDialog,
    private authService: AuthService,
    private router: Router, ) { }

  addVersion() {

    // session details
    var sessionExpireTime = parseInt(localStorage.getItem('sessionExpireTime'));

    if (this.date.getTime() >= sessionExpireTime) {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'JIRA Session Expired' });

      setTimeout(() => {
        this.authService.logout();
        this.router.navigate(['/Login']);
      },
        1500);

    } else {

      const dialogRef = this.dialog.open(NewVersionComponent, {
        width: '1100px',
        data: "",
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == undefined) {
          // this.search();
        } else {
          // this.updateQA(result.data, result.qa);
        }

      });
    }


  }
  ngOnInit() {

  }

}
